(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.fnLabelPrinter = function () {

        if (window.labelPrinter !== undefined) {
            return window.labelPrinter;
        }

        let labelPrinter = {};

        labelPrinter.noDevices = null;

        window.labelPrinterDevices = [];

        /**
         *
         * @param showElements
         * @param data
         * @param type
         * @returns {string | null}
         */
        labelPrinter.getTemplate = (showElements, data, type) => {
            let labelSettings = labelPrinter.getSettings(type);

            if (labelSettings === null) {
                return null;
            }

            let template = null;

            switch (type) {
                case 'box':
                    template = labelPrinter.getBoxTemplate(showElements, data);
                    break;
                case 'spool':
                    template = labelPrinter.getSpoolTemplate(labelSettings, showElements, data);
                    break;
                default:
                    console.error('label type [' + type + '] not known.');
                    return null;
            }

            console.log(template);

            return template;
        }

        /**
         * @param type
         */
        labelPrinter.getSettings = (type) => {
            const imgSrc = $('#label-printer-logo');
            let settings = {
                positionLeft: 30,
                positionRight: 220,
                top: 20,
                interval: 45,
                spacing: 0,
                fontSize: 22,
                img: null,
                lastPosition: 0
            };

            switch (type) {
                case 'box':
                    // TODO: Size and position not yet known
                    settings.fontSize = 36;
                    settings.img = imgSrc.attr('data-box-src');
                    settings.interval = 50;
                    settings.positionLeft = 30;
                    settings.positionRight = 340;
                    settings.spacing = 0;
                    settings.top = 20;
                    break;
                case 'spool':
                    // 7 x 5 cm
                    settings.fontSize = 23;
                    settings.img = imgSrc.attr('data-spool-src');
                    settings.interval = 48;
                    settings.positionLeft = 130;
                    settings.positionRight = 260;
                    settings.spacing = 0;
                    settings.top = 44;
                    break;
                default:
                    console.error('label type [' + type + '] not known.');
                    return null;
            }
            return settings;
        }

        /**
         * @param labelSettings
         * @param data
         * @param showElements
         */
        labelPrinter.getSpoolTemplate = (labelSettings, showElements, data) => {
            // Start & font setting
            let template = [];
            template.push("^XA");

            // Font setting
            template.push("^CFA," + labelSettings.fontSize);

            // Count element loop
            let count = 0;

            if (showElements.pid) {
                count++;
                labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDPID^FS");
                template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + data.pid + '^FS');
            }

            if (showElements.code) {
                count++;
                labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDitem#^FS");
                template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + data.code + '^FS');
            }

            if (showElements.batch_name) {
                count++;
                labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDbatch#^FS");
                if (showElements.tube_int) {
                    template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + data.batch_name + '-' + data.box_int + '-' + data.tube_int + '^FS');
                } else {
                    template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + data.batch_name + '-' + data.box_int + '^FS');
                }
            }

            if (showElements.netto_weight) {
                count++;
                labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDnet.wt^FS");
                template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + parseFloat(data.netto_weight).toFixed(2) + ' kg^FS');
            }

            if (showElements.gross_weight) {
                count++;
                labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDgr.wt^FS");
                template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + parseFloat(data.gross_weight).toFixed(2) + ' kg^FS');
            }

            if (showElements.meters) {
                if (parseFloat(data.meters) > 0) {
                    count++;
                    labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : labelSettings.top);
                    template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDlength^FS");
                    template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + parseFloat(data.meters).toFixed(2) + ' m.^FS');
                }
            }

            if (showElements.customer_code) {
                if (data.customer_code !== '') {
                    count++;
                    labelSettings.spacing += ((labelSettings.spacing > 0) ? labelSettings.interval : top);
                    template.push("^FO" + labelSettings.positionLeft + "," + labelSettings.spacing + "^FDcust.#^FS");
                    template.push("^FO" + labelSettings.positionRight + "," + labelSettings.spacing + "^FD" + data.customer_code + '^FS');
                }
            }

           let  loop = 8;

            // Horizontal lines with increased thickness
            for (let i = 0; i < loop; i++) {
                labelSettings.lastPosition = labelSettings.interval * i + 28;

                if (i < 3) {
                    template.push("^FO118," + labelSettings.lastPosition + "^GB598,1,3,2^FS");
                } else {
                    template.push("^FO118," + labelSettings.lastPosition + "^GB498,1,3,2^FS");
                }
            }

            // Add the final line
            labelSettings.lastPosition = labelSettings.interval * loop + 28;
            template.push("^FO118," + labelSettings.lastPosition + "^GB498,1,3,2^FS");

            template.push("^FO118,28^GB1,386,3,2^FS");


            // Vertical lines with height up to the last position
            template.push("^FO244,28^GB1,388,3,2^FS");

            // Second vertical line
            template.push("^FO616,124^GB1,290,3,2^FS");

            template.push("^FO714,28^GB1,100,3,2^FS");

            if (labelSettings.img !== null) {
                template.push("^FO638,48^GFA," + labelSettings.img);
            }

            // Add qr to website
            template.push("^FO628,318^BQN,2,3^FDLA,https://swift-fiber.com^FS");

            template.push("^XZ");

            template = template.join("\n");

            return template;
        }

        /**
         * @param showElements
         * @param data
         */
        labelPrinter.getBoxTemplate = (showElements, data) => {
            let template = [];
            template.push("^XA");
            template.push("^CI28");
            template.push("^PW1746");
            template.push("^LL2478");

            template.push("^FO80,160^GFA,31392,31392,144,,::gP03IF,gM01LF,gK03MF8,gI07NF8,gH0OFV0IF,gG0OF8S03KF8,g0OF8R0NF8,Y0OFQ01PF8,X07NFQ0RF8gU0SFI07IFEN03JFCN03IFEI0JFCR0NFEI0WFCgN0FCI018I03K07K0FFJ07JFCK03I0C001I0C00KF8018I06,W03NFP03RFEgT01TFI07IFEN07JFCN03IFEI0JFCP03OFEI0WFCgM03FFI01CI078J07K0IF8007JFCK07I0E003800C00KF801CI06,V01NFP07SFCgT0UFI07JFN07JFEN07IFEI0JFCO07PFEI0WFCgM0IF8001CI07K078J0IFC007JFCK03001E003I0C00KF801CI06,V07LFEO01TFE8gS03UFI03JFN07JFEN07IFEI0JFCN03QFEI0WFCgM0E018001EI0F8J0F8J0C01EJ038M03801E003I0CJ07J01CI06,V0MFO01VFgT0VFI03JFN07JFEN07IFCI0JFCN0RFEI0WFCgL01CK03EI0F8J0F8J0C00EJ038M03801E007I0CJ07J01CI06,U03LFO03UFECgS03VFI03JFN0LFN07IFCI0JFCM03RFEI0WFCgL01CK03F001F8J0DCJ0C007J038M01803F007I0CJ07J01CI06,U07KF8N03VFBgT07VFI01JF8M0LFN0JFCI0JFCM07RFEI0WFCgL018K03F001D8I01CCJ0C007J038M01803B006I0CJ07J01CI06,U0KF8N07WFCgT0WFI01JF8M0LFN0JF8I0JFCL01SFEI0WFCgL038K03B00198I018EJ0C007J038M01C033006I0CJ07J01CI06,T01JFCN03XFgT01WFI01JFCM0LFN0JF8I0JFCL03SFEI0WFCgL018K03B80398I038EJ0C007J038M01C03300EI0CJ07J01CI06,T02IFEN03XF8gT03WFJ0JFCL01LF8L01JF8I0JFCL07SFEI0WFCgL01CK03980318I0306J0C007J038N0C07380EI0CJ07J01CI06,T03IF8M01WFDEgU03WFJ0JFCL01LF8L01JF8I0JFCL0TFEI0WFCgL01EK031C0718I0307J0C007J038N0C07180CI0CJ07J01CI06,T07FFEM03XFEgV03WFJ0JFCL01LF8L01JFJ0JFCL0TFEI0WFCgM0F8J030C0718I0707J0C00EJ038N0E06181CI0CJ07J01CI06,T07FF8L01XFCgW07WFJ07IFEL01LFCL01JFJ0JFCK01TFEI0WFCgM03EJ030E0E18I0603J0C01EJ038N0E061C1CI0CJ07J01JFE,T07FFM0XFgY0XFJ07IFEL03LFCL03JFJ0JFCK01TFEI0WFCgM01FCI03060E18I0E038I0IFCJ038N060E1C1CI0CJ07J01JFE,T07FCL0VFEhG0XFJ07IFEL03LFCL03IFEJ0JFCK03MFAV07JFgU03EI03071C18I0E018I0IFK038N060C0C18I0CJ07J01JFE,T07FCK07TFhJ0LFV03IFEL03LFEL03IFEJ0JFCK03KFEX03JFgV0FI07031C1CI0C01CI0FFEK038N070C0C38I0CJ07J01CI06,T07FEJ03SFhL0KF8V03JFL03LFEL07IFEJ0JFCK07KFY03JFgV07800303181C001IFCI0C07K038N071C0E38I0CJ07J01CI06,T05FF8003RF8hL01KFW03JFL07LFEL07IFCJ0JFCK07JFCY03JFgV03C00701B81C001IFCI0C038J038N031C0E3J0CJ07J01CI06,T03FFC01QFChN01JFEW01JFL07LFEL07IFCJ0JFCK0KF8Y03JFgV01C00701F01C001C01EI0C038J038N0318063J0CJ07J01CI06,T03IF0PFhQ01JFCW01JF8K07MFL07IFCJ0JFCK0JFEg03JFgV01C00701F01C003800EI0C01CJ038N0398077J0CJ07J01CI06,T01RFhS01JF8W01JF8K07MFL0JF8J0JFCK0JFEg03JFgV01C00700E01C003I0EI0C01CJ038N03B8077J0CJ07J01CI06,U0PFChT01JF8X0JF8K0NFL0JF8J0JFCK0JFCg03JFgV01C00700E00C007I07I0C00EJ038N01B8076J0CJ07J01CI06,U0NFEhV01JF8X0JFCK0IFEJFL0JF8J0JFCJ01JF8g03JFgS01001C006K0C007I07I0C00EJ038N01B003EJ0CJ07J01CI06,U07KF8hX01JF8X0JFCK0IFE7IF8K0JFK0JFCJ01JF8g03JFgS03C038007K0C006I03I0C007J038N01F003EJ0CJ07J01CI06,U03JFEhY01JF8X07IFCK0IFE7IF8J01JFK0JFCJ01JFgG03JFgS01F9FI06K0C00EI03800C007J038O0F003EJ0CJ07J01CI06,U01KF8Y03FCgV01JF8X07IFEJ01IFE7IFCJ01JFK0JFCJ01JFgG03JFgT0FFEI06K0E00EI01801C0038I038O0F001CJ0CJ07J01CI06,V0LFW03IF4gV01JF8X07IFEJ01IFC3IFCJ01JFK0JFCJ01JFgG03JFgT03F8I06K0C00CI01800C0018I018O0E001CJ0CJ03J018I06,V07KFET07KF8gV01JF8X03IFEJ01IFC3IFCJ03IFEK0JFCJ03IFEgG03JF,V03LF8Q0MFEgW01JF8X03IFEJ01IFC3IFCJ03IFEK0JFCJ03IFEgG03JF,W0MF8N07NF8gW01JF8X03JFJ03IFC3IFEJ03IFEK0JFCJ03IFEgG03JF,W07LFCL07OFEgX01JFCX01JFJ03IF81IFEJ03IFCK0JFCJ03IFEgG03JF,S01I03MF8I0QFEgY01JFEX01JFJ03IF81IFEJ07IFCK0JFCJ03IFEgG03JF,S01J0NF3SFh01KFX01JF8I07IF81IFEJ07IFCK0JFCJ03IFEgG03JF,S028I03gF8h01KFCX0JF8I07IF81JFJ07IF8K0JFCJ03IFCgG03JF,S03CI01YFChH0MF7KF8P0JF8I07IF00JFJ0JF8K0JFCJ07IFE7PFEO03JF,S03EJ07WF8hI0UFCN0JFCI07IF00JFJ0JF8K0JFCJ07UFEO03JF,S03FJ01VF8hJ0VF8M07IFCI07IF00JF8I0JF8K0JFCJ07UFEO03JF,S01F8J07TF8hK07UFEM07IFCI0JF007IF8I0JFL0JFCJ07UFEO03JF,S01FCJ01SFhM07VF8L07IFCI0IFE007IF8001JFL0JFCJ07UFEO03JF,T0FEK07PFChN03VFCL03IFEI0IFE007IFC001JFL0JFCJ07UFEO03JF,T0FF8J01OFChO01VFEL03IFE001IFE007IFC001IFEL0JFCJ07UFEO03JF,T07FEK07OF8hO0WFL03IFE001IFE003IFC003IFEL0JFCJ07UFEO03JF,T07FFL0OFChO07VFL01JF001IFE003IFC003IFEL0JFCJ07UFEO03JF,T03FFCK01OF8hN03VF8K01JF001IFC003IFE003IFCL0JFCJ07UFEO03JF,T01IFL07OFhN01VFCK01JF001IFC001IFE003IFCL0JFCJ07UFEO03JF,U0IFCL0OFEhN07UFCL0JF003IFC001IFE007IFCL0JFCJ07UFEO03JF,U0JFL03OFChM01UFCL0JF803IFC001JF007IF8L0JFCJ07UFEO03JF,U07IFCL07OFhN01TFEL0JF803IF8001JF007IF8L0JFCJ07UFEO03JF,U03JFM0OFEhP0RFEL07IF803IF8I0JF007IF8L0JFCJ07IFEQ02O03JF,V0JFCL01OFChV0KFEL07IFC07IF8I0JF00JF8L0JFCJ07IFCgG03JF,S06007JFM07OFhV03JFEL07IFC07IF8I0JF80JFM0JFCJ07IFCgG03JF,S04003JFEM0OFEhV0KFL03IFC07IFJ07IF80JFM0JFCJ07IFCgG03JF,S04I0KF8L01OFChU07JFL03IFE07IFJ07IF81IFEM0JFCJ07IFCgG03JFiI01F,S07I07KFM03OF8hT07JFL03IFE0JFJ07IFC1IFEM0JFCJ07IFCgG03JFgT0CI0EI03I07FFEJ038I0CI07FE007JFE00IF8I07J01CJ03,S07I03KFCM07NFEhT03JFL01IFE0IFEJ03IFC1IFEM0JFCJ07IFCgG03JFgT0C001EI03I07IF8I038I0CI0IF807JFC00IFEI07J01EJ03,S078I0LFN0OFChS03JFL01JF0IFEJ03IFC3IFEM0JFCJ07IFCgG03JFgT0CI0FI03I07007EI038I0C001E03J018J0E01EI07J03EJ03,S078I03KFEM03OF8hR03JFL01JF1IFEJ03IFE3IFCM0JFCJ07IFCgG03JFgT0CI0F8003I07I0FI038I0C0038L018J0E007I07J037J03,S07CI01LF8M07OFhR03JFM0JF1IFEJ03IFE3IFCM0JFCJ07IFCgG03JFgT0CI0F8003I07I07I038I0C0038L018J0E007I07J037J03,S07EJ07KFEN0OFChQ03JFM0JF1IFEJ01IFE3IFCM0JFCJ07IFCgG03JFgT0CI0DC003I07I0380038I0C003M018J0E0038007J077J03,S01FJ01LF8M01OFhQ03JFM0JF9IFCJ01IFE7IF8M0JFCJ07IFCgG03JFgT0CI0CE003I07I0180038I0C003M018J0E0038007J063J03,S03FK07LFN07NFEhP03JFM07IFBIFCJ01JF7IF8M0JFCJ07IFCgG03JFgT0CI0C7003I07I01C0038I0C003M018J0E0038007J0E38I03,S03F8J03LFCM01OFChO03JFM07IFBIFCJ01JF7IF8M0JFCJ07IFCgG03JFgT0CI0C7003I07J0C0038I0C0038L018J0E0038007J0C18I03,S03FCK0MF8M03OF8hN03JFM07MFCK0NFN0JFCJ07IFCgG03JFgT0CI0C3803I07J0E0038I0C001CL018J0E003I07J0C1CI03,S01FEK03LFEN07OFhN07JFM03MF8K0NFN0JFCJ07IFCgG03JFgT0CI0C1C03I07J0E0038I0C001FL018J0E007I07I01C0CI03,S01FF8K0MF8N0OFEhM0KFM03MF8K0NFN0JFCJ07IFCgG03JFgT0CI0C1C03I07J0E0038I0CI0FCK018J0E00EI07I01C0CI03,S01FFCK01MFN01OF8hK01JFEM03MF8K07LFEN0JFCJ07IFCgG03JFgT0CI0C0E03I07J0E0038I0CI03FK018J0E07EI07I0380EI03,T0IFL07LFCN07OFhK0KFEM03MF8K07LFEN0JFCJ07IFCgG03JFgT0CI0C0703I07J0E0038I0CJ0FCJ018J0IF8I07I0380EI03,T07FFCK01MFO0OFEgQ03WFEM01MFL07LFEN0JFCJ07IFCgG03JFgT0CI0C0783I07J0E0038I0CJ01EJ018J0IFJ07I03007I03,T07IFL07LFEN03OF8gP03WFCM01MFL07LFEN0JFCJ07IFCgG03JFgT0CI0C0383I07J0E0038I0CK0FJ018J0E038I07I03IFI03,T03IFCK01MFCN07OFgP03WFCM01MFL03LFCN0JFCJ07IFCgG03JFgT0CI0C01C3I07J0C0038I0CK078I018J0E038I07I07IFI03,T01JF8K03MFO0OFCgO03WFCN0LFEL03LFCN0JFCJ07IFCgG03JFgT0CI0C00E3I07I01C0038I0CK038I018J0E01CI07I07IF8003,T01JFEL0MFEN01OF8gN03WF8N0LFEL03LFCN0JFCJ07IFCgG03JFgT0CI0C00E7I07I01C0038001CK018I018J0E01CI07I0E0038003,U0KF8K01MFCN07OFgN03WF8N07KFEL01LF8N0JFCJ07IFCgG03JFgT0CI0C0073I07I0380038001CK018I018J0E00EI07I0E0018003,U07JFEL07MF8M01OFEgM03WFO07KFEL01LF8N0JFCJ07IFCgG03JFgT0CI0C003BI07I038001C0038K038I018J0E00EI07I0C001C003,U03KF8L0MFEN03OF8gL03VFEO07KFEL01LF8N0JFCJ07IFCgG03JFgT0CI0C003FI07I0FI01C00380020038I018J0E007I07001C001C003,U01LFL01MFCN07OFgL03VFCO03KFCL01LFO0JFCJ07IFCgG03JFgT0CI0C001FI07001EJ0E007I07807J018J0E003I07001CI0C003,V0LFCL07MF8N0OFEgK03VF8O03KFCM0LFO0JFCJ07IFCgG03JFgT0CI0CI0FI0783FCJ0783EI03E1FJ018J0E00380070018I0E0038,V07LFL01NFN03OF8gJ03UFEP03KFCM0LFO0JFCJ07IFCgG03JFgT0C001CI07I07IFK03FFCI01FFEJ018J0E001C0070038I0E003IF,V01LFCL03MFCN07NFEgJ03UFCP03KFCM0LFO0JFCJ07IFCgG03JFgT0CI0CI07I07FFCL0FF8J07F8J018J0E001C007003J06003IF,W0MFM07MF8M01OFCgI03TFEQ01KF8M07JFEO0JFCJ07IFCgG03JF,W07LFEL01NFN03OF8gH03TFR01KF8M07JFEO0JFCJ07IFCgG03JF,W01MF8L03MFEN0PFgH03RFCS01KF8M07JFEO0JFCJ07IFCgG03JF,X0MFEM07MFCM01OFC,X03MFCL01NFN03OF,Y0NFM07MFEN07NFC,Y07MFEM0NFCM01OF,Y01NF8L01NF8M03NFC,g07NFM03NFN07NF,g01NFCM0NFCN0NFC,gG07NFM01NF8M01MFE,gH0NFEM07NFN07MF8,gH03NF8M0NFEN0MFC,gI0NFEM01NFCM01MF,gI01NFCM03NF8M07LF8,gJ0OF8M0OFN0LFC,gJ01NFEM01NFEM01KFE,gK07NFCM07NFCM07KF,gK01OFN0OFM01KF8,gL07NFCM01NFEM07JFC,gM0OF8M03NFCL01JFE,gM03NFEN07NF8L07JF,gN07NFCM01OFL01JF8,gN01OFN07NFCL07IF8gG07NFEI01JF8J0SFU0OFCJ03RFE,gO03NFEN0OF8K01IFCY01PFEI01JF8J0TFS0PFCJ03SFE,gP0OFCM01OFL07FFEX01QFEI01JF8J0UFQ0QFCJ03TF8,gP03OFN03NFEK01FFEX0RFEI01JF8J0UFEO03QFCJ03TFEhH0IFC006I0IF8I07IFI0IF8,gQ0OFCN0OFCK0IFW03RFEI01JF8J0VF8N0RFCJ03UFhH0IFC006I0IFCI07IFI0IFC,gQ01OF8M01NFEK03FFW0SFEI01JF8J0VFCM03RFCJ03UFChG0CK06I0E01EI07L0E01E,gR07NFEN07NFCJ01FF8U01SFEI01JF8J0VFEM07RFCJ03UFEhG0CK06I0E007I07L0E00F,gS0OFCN0OFK07F8U03SFEI01JF8J0WFL01SFCJ03VFhG0CK06I0E007I07L0E007,gS03OF8M03NFCJ03F8U07SFEI01JF8J0WFL03SFCJ03VFhG0CK06I0E003I07L0E003,gT07NFEN07NFJ01FCU0TFEI01JF8J0WF8K07SFCJ03VF8h0CK06I0E003I07L0E0038,gU0OF8N0NFCJ0FCT01TFEI01JF8J0WFCK0TFCJ03VFCh0CK06I0E003I07L0E0038,gU03OFN03NFJ07CT01TFEI01JF8J0WFCJ01TFCJ03VFCh0CK06I0E007I07L0E0038,gV0OFEN0NFCI03CT03TFEI01JF8J0WFCJ01TFCJ03VFEh0CK06I0E006I07L0E003,gV01OF8M01MFEI01CT03TFEI01JF8J0WFEJ03TFCJ03VFEh0CK06I0E00EI07L0E007,gW03OFN07MF8003CT07LF8Q01JF8J0JFCK01LFEJ03LF8R03IFEK01LFEh0CK06I0IFCI07L0E00F,gX0OFEN0MFC00FCT07KFS01JF8J0JF8M0KFEJ07KF8S03IFEM07KFh0IFI06I0IFCI07FFCI0E07E,gX01OF8M03MF03FCT0KFCS01JF8J0JF8M03KFJ0KFET03IFEN0KFh0IFI06I0F01EI07FFCI0IFC,gY03NFEN07LF8FFCT0KFT01JF8J0JF8M01KFJ0KFCT03IFEN07JFh0EK06I0E007I07L0IF,h07NFCM01OFCS01JFET01JF8J0JF8N0KFJ0KFU03IFEN03JFh0CK06I0E0038007L0E03,h01OF8M07NFCS01JFCT01JF8J0JF8N07JFI01JFEU03IFEN01JFh0CK06I0E0038007L0E038,hG03OFM01NFCS01JF8T01JF8J0JF8N07JFI01JFEU03IFEN01JF8gY0CK06I0E0018007L0E01C,hH07NFCM0NF8S01JF8T01JF8J0JF8N03JFI03JFCU03IFEN01JF8gY0CK06I0E0018007L0E01C,hI0OF8I07FENF8S03JFU01JF8J0JF8N03JFI03JFCU03IFEN01JF8gY0CK06I0E0018007L0E00E,hI01RF8PFT03JFU01JF8J0JF8N03JFI07JF8U03IFEN01JF8gY0CK06I0E0038007L0E00E,hH01BgIFT03IFEU01JF8J0JF8N03JFI07JF8U03IFEN01JF8gY0CK06I0E0038007L0E007,U07hPFET03IFEU01JF8J0JF8N03JFI07JFV03IFEN01JF8gY0CK06I0E007I07L0E007,S01F4hPFCT03IFEU01JF8J0JF8N07JFI07JFV03IFEN01JF8gY0CK06I0E01EI07L0E0038,R03EhRF8T07IFCU01JF8J0JF8N07IFEI07JFV03IFEN01JF8gY0CK06I0IFCI07IF800E0038,Q01hTFU07IFCU01JF8J0JF8N07IFEI0JFEV03IFEN01JF8gY0CK06I0IFJ07IF800E001C,Q0hUFU07IFCU01JF8J0JF8N0JFEI0JFEV03IFEN01JF8,P02hUF8T07IFCU01JF8J0JF8M01JFCI0JFEV03IFEN03JF,P0hVF8T07IFCU01JF8J0JF8M03JFCI0JFEV03IFEN03JF,O07hVF8T07IFCU01JF8J0JF8M0KF8I0JFEV03IFEN07JF,N01hPFD7FC1FF8T07IFCU01JF8J0WFJ0VFCJ03IFEM01KF,N07hQFJ0FF8T0VFEI01JF8J0WFJ0VFCJ03IFEL01KFE,M01BhPF8J07F8T07UFEI01JF8J0VFEI01VFCJ03VFE,M03hIF7MFEJ03F8T0VFEI01JF8J0VFCI01VFCJ03VFC,M0hFE9FFD03LFJ01FU0VFEI01JF8J0VF8I01VFCJ03VFC,L03gXFE7FCK07KFCI03FU0VFEI01JF8J0UFEJ01VFCJ03VF8,L0gYFP0KFE003DCU0VFEI01JF8J0UFCJ01VFCJ03VF8,K03gQFEJFS03KF83FFEU0VFEI01JF8J0UFK01VFCJ03VF,K07gNFE7IFW07NF8U0VFEI01JF8J0UFCJ01VFCJ03UFE,J017gLF3FFgG01NFCU0VFEI01JF8J0UFEJ01VFCJ03UFC,J07gLF8gJ01NF8U0VFEI01JF8J0VF8I01VFCJ03UF8,J0gJFgL01PF8U0VFEI01JF8J0VFCI01VFCJ03TFE,I03VFC7IFgM07QFEV0VFEI01JF8J0VFEI01VFCJ03TF8,I05SFCFFEgN05FCRFCV0VFEI01JF8J0WFI01VFCJ03SFE,I03SFgO07FF8TF8V0VFEI01JF8J0WF8001JFEV03SF8,I07OFAgO03gFW0JF8U01JF8J0JF8M0KFCI0JFEV03SF8,I037C7IFgQ0gHFEW0JF8U01JF8J0JF8M03JFCI0JFEV03NFDJFC,J0FE8gP05FE7gHFCW0JF8U01JF8J0JF8M01JFEI0JFEV03IFEK0JFC,gT0IF8gKFCW0JF8U01JF8J0JF8N0JFEI0JFEV03IFEK0JFE,gP01IFEgNFCW0JF8U01JF8J0JF8N07JFI0JFEV03IFEK07IFE,gN0gRFEEFEW0JF8U01JF8J0JF8N07JFI0JFEV03IFEK03JF,gJ07FE7gQFEF03EW0JF8U01JF8J0JF8N03JFI0JFEV03IFEK03JF8jI04gI01,g07FFE3gTFE001EW0JF8U01JF8J0JF8N03JFI07IFEV03IFEK01JF8hG0KFC01IFCJ0FFEI018I06I0EI038J0FFEJ038L07FEL07FFI07I038,W07IFBgVF8J0EW0JF8U01JF8J0JF8N03JFI07JFV03IFEK01JFChG0KFC01IFCI03IF80018I0EI0FI038I03IF8I038K01IF8J01IFC0038003,T07gYFBFCL04W0JF8U01JF8J0JF8N03JFI07JFV03IFEL0JFChI038I01CL07C07C0018I06I0F80038I07C07CI038K07C07CJ07C03E0018007,P03FF3gXFC7CN0EW0JF8U01JF8J0JF8N03JF8003JF8U03IFEL07IFEhI03J01CL0FI0C0018I06I0F80038I0F001EI038K0F001EJ0FI0E001C00E,L017FF17hFCO03CW0JF8U01JF8J0JF8N03JF8003JF8U03IFEL07JFhI03J01CK01EL018I06I0FC0038001EI07I038J01EI07I01EM0E00E,J0IFDhIFQ0FCW0JF8U01JF8J0JF8N03JF8003JFCU03IFEL03JFhI03J01CK03CL018I06I0EE0038003CI0380038J03CI038001CM0E01C,007hJF7FCQ07FEW0JF8U01JF8J0JF8N07JFI01JFEU03IFEL03JF8hH03J01CK038L018I06I0EE00380038I0380038J038I0180038M07038,07hIFCF8R0F7FCW0JF8U01JF8J0JF8N07JFI01JFEU03IFEL01JF8hH03J01CK07M018I06I0E70038007J01C0038J07J01C0038M03038,37hIF8R07EIFCW0JF8U01JF8J0JF8N0KFI01KFU03IFEL01JFChH03J01CK07M018I06I0E38038007J01C0038J07K0C007N0387,7hHFCR03LF8W0JF8U01JF8J0JF8N0KFJ0KF8T03IFEM0JFChH03J01CK06M018I0EI0E1C038006K0E0038J07K0E007N01C7,7gXFCFFS0NFX0JF8U01JF8J0JF8M03KFJ0KFCT03IFEM07IFEhH03J01CK0EM018I06I0E1C03800EK0E0038J0EK0E007N01CE,gXF7FS07DMFEX0JF8U01JF8J0JF8M0LFJ07KF8S03IFEM07JFhH03J01CK0EM018I0EI0E0E03800EK0E0038J0EK0E007O0EE,gWFES0BF3NFCX0JF8U01JF8J0WFEJ07MFELFCJ03IFEM03JFhH03J01IFI0EM01JFEI0E0703800EK0E0038J0EK0E006O0FC,gVF8R03RF8X0JF8U01JF8J0WFEJ03TFCJ03IFEM03JF8hG03J01IFI0EM01JFEI0E0703800EK0E0038J0EK0E006J01J078,3gQF7FCS0TFY0JF8U01JF8J0WFEJ01TFCJ03IFEM01JFChG03J01CK0EM018I0EI0E0383800EK0E0038J0EK0E006I03FJ038,7gOF9F8S07DSFCY0JF8U01JF8J0WFCK0TFCJ03IFEM01JFChG03J01CK0EM018I06I0E01C3800EK0C0038J06K0E007I03FJ03,3gOF8S07E7TFg0JF8U01JF8J0WFCK0TFCJ03IFEN0JFEhG03J01CK06M018I06I0E01C38007K0C0038J07K0C007J03J03,2gMF8S03FDUFCg0JF8U01JF8J0WF8K07SFCJ03IFEN0JFEhG03J01CK07M018I06I0E00E38007J01C0038J07J01C007J03J03,1gHFE7FCS01XFBgG0JF8U01JF8J0WFL01SFCJ03IFEN07JFhG03J01CK07M018I06I0E00738007J01C0038J07J01C0038I03J03,0gFE3F8T0FBXFCgG0JF8U01JF8J0WFM0SFCJ03IFEN07JF8h03J01CK038L018I06I0E003B80038I0380038J038I0380038I03J03,05gFU0FE7XFCgH0JF8U01JF8J0VFEM07RFCJ03IFEN03JF8h03J01CK03CL018I06I0E003B8003CI0780038J03CI038001CI03J03,03XFU07FBYFEgI0JF8U01JF8J0VFCM01RFCJ03IFEN03JFCh03J01CK01CI060018I06I0E001F8001EI0FI038J01EI07I01EI07J03,00SF7FEU03gGFDEgJ0JF8U01JF8J0VFO0RFCJ03IFEN01JFCh03J01CL0FI0E0018I06I0EI0F8I0F001EI038K0F001EJ0F001FJ03,005OFE3F8U03F7gFDEgK0JF8U01JF8J0UFCO03QFCJ03IFEO0JFEh03J01CL07C03E0018I06I0EI0F8I07C07CI038K07C07CJ07C07FJ03,003PFV01FDgHFEgL0JF8U01JF8J0TFEQ07PFCJ03IFEO0JFEh03J01IFEI03IF80018I06I0EI078I01IF8I03IF8001IF8J01IF3J03,I0MFCV01FF7gHFCgM0JF8U01JF8J0SFES0PFCJ03IFEO07JFh03J01IFEJ0FFEI018I06I0EI038J0FFEJ03IF8I07FEL07FC3J03,I01JFX07gKFCgN0JF8U01JF8J0RF8V01MFCJ03IFEO03JFhU0EgJ0FT07N06,gJ07DgJFBC,gH07E7gKF8,g07gNF8,X03gOF8,V03F7gLFCE,T03F9gNFE,R03FEgOFC,Q0gQF7C,P02gOFE78,P03gPF,P02gNFE,P01gLF7C,Q05gIFCF8,Q03gIFE,R0gHFC,R03XFDF8,S0EVFBE,S01VFC,T07SFE,U07OFBF8,U01DLFC7E,V01DJFBE,W01IFE,^FS");
            template.push("^FO1330,140^BQN,2,10^FDLA,https://swift-fiber.com^FS");

            // PID
            if (showElements.pid) {
                template.push("^FO80,570^A0N,70,70^FDPID:^FS");
                template.push(`^FO80,670^A0N,100,100^FD${data.pid}^FS`);
            }

            // Lines for block Item and Customer Item No.
            template.push("^FO80,800^GB1570,6,6^FS");
            template.push("^FO80,1014^GB1570,6,6^FS");
            template.push("^FO80,800^GB6,220,6^FS");
            template.push("^FO890,800^GB6,220,6^FS");
            template.push("^FO1644,800^GB6,220,6^FS");

            // Item headers
            template.push("^FO110,830^A0N,70,70^FDItem No.^FS");
            template.push("^FO920,830^A0N,70,70^FDCustomer Item No.^FS");

            if (showElements.code) {
                template.push(`^FO110,920^A0N,70,70^FD${data.code}^FS`);
            }

            if (showElements.customer_code) {
                template.push(`^FO920,930^A0N,70,70^FD${data.customer_code}^FS`);
            }

            // Box number
            if (showElements.box_nr) {
                template.push(`^FO80,1190^A0N,100,100^FDBox No.: ${data.number}^FS`);
            }

            // Block for weight, reels and meters
            template.push("^FO80,1320^GB1570,6,6^FS");
            template.push("^FO80,1320^GB6,540,6^FS");
            template.push("^FO890,1320^GB6,540,6^FS");
            template.push("^FO1644,1320^GB6,540,6^FS");
            template.push("^FO80,1590^GB1570,6,6^FS");
            template.push("^FO80,1860^GB1570,6,6^FS");

            if (showElements.netto_weight) {
                template.push("^FO110,1360^A0N,70,70^FDNet Weight^FS");
                template.push(`^FO110,1460^A0N,100,100^FD${parseFloat(data.netto_weight).toFixed(2)} kg^FS`);
            }

            if (showElements.gross_weight) {
                template.push("^FO920,1360^A0N,80,80^FDGross Weight^FS");
                template.push(`^FO920,1460^A0N,100,100^FD${parseFloat(data.gross_weight).toFixed(2)} kg^FS`);
            }

            if (showElements.reels) {
                template.push("^FO110,1630^A0N,70,70^FDNo. of Spools^FS");
                template.push(`^FO110,1730^A0N,100,100^FD${data.reels}^FS`);
            }

            if (showElements.meters && data.meters !== null) {
                template.push("^FO920,1630^A0N,70,70^FDLength^FS");
                template.push(`^FO920,1730^A0N,100,100^FD${parseFloat(data.meters).toFixed(2)} m^FS`);
            }

            // Block for batch and reel list
            template.push("^FO80,1860^GB1570,6,6^FS");
            template.push("^FO80,1980^GB1570,6,6^FS");
            template.push("^FO80,1980^GB6,262,6^FS");
            template.push("^FO1644,1980^GB6,262,6^FS");
            template.push("^FO80,2110^GB1570,6,6^FS");
            template.push("^FO80,2240^GB1570,6,6^FS");

            if (showElements.batch_name) {
                template.push("^FO110,2018^A0N,80,80^FDBatch No: " + data.batch_name + "^FS");
            }
            console.log(data)

            if (showElements.reel_list) {
                template.push("^FO110,2142^A0N,80,80^FD"+data.reel_list+"^FS");
            }

            template.push("^XZ");
            return template.join("\n");
        };


        /**
         * @param uid
         */
        labelPrinter.getDeviceByUid = (uid) => {
            let devices = labelPrinter.getDevices();
            let deviceByUid = null;
            devices.forEach((device) => {
                if (device.uid === uid) {
                    deviceByUid = device;
                }
            })
            return deviceByUid;
        }

        /**
         *
         * @returns {[]}
         */
        labelPrinter.getDevices = () => {
            if (window.labelPrinterDevices.length < 1) {
                labelPrinter.setDevices();
            }
            return window.labelPrinterDevices;
        }

        /**
         * Sets the devices for the label printer.
         */
        labelPrinter.setDevices = () => {
            BrowserPrint.getLocalDevices((device_list) => {
                    device_list.forEach((device) => {
                        window.labelPrinterDevices.push(device);
                        labelPrinter.noDevices = false;
                    });
                },
                () => console.error("Error getting local devices"),
                "printer"
            );
        }

        /**
         *
         * @param device
         * @param content
         */
        labelPrinter.write = (printer, content) => {
            console.info(content);
            if (labelPrinter.noDevices === true) {
                console.error('labelPrinter.noDevices');
                return;
            }
            if ((printer === null)) {
                console.error('printer === null');
                if (labelPrinter.noDevices === false) {
                    return;
                }
                if (labelPrinter.noDevices === true) {
                    $('[data-toggle="#data-side-panel-edit-label-printers"]').click();
                    return;
                }
                return;
            }

            printer.send(content, undefined, (error) => {
                console.error(error);
            });
        }

        /**
         *
         */
        labelPrinter.init = () => {
            if (labelPrinter.initialized === undefined) {
                labelPrinter.initialized = true;
            }
            labelPrinter.setDevices();
        }


        /**
         *
         * @param errorMessage
         */
        labelPrinter.errorCallback = (errorMessage) => {
            console.error("Error: " + errorMessage);
        }

        labelPrinter.init();

        window.labelPrinter = labelPrinter;
        return window.labelPrinter;
    }

}(jQuery));
